import React from 'react';

const CheckSeleccion = ({ checked, disabled, onChange, label, title }) => (
    <label className='check_seleccion' title={title}>
        <input type="checkbox" className="filled-in" checked={checked} disabled={disabled} onChange={onChange} />
        <span>{label}</span>
    </label>
);

export default CheckSeleccion;
